import { Navigate, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/session/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Navigate from={Route.fullPath} to="./login" />
}
